import React, { FC, useEffect, useRef, useState } from 'react';
import cn from 'classnames';
import { FiChevronDown } from 'react-icons/fi';
import css from './styles.module.scss';

interface IAccordionProps {
  title: string | React.ReactNode; // Текст шапки
  isOpen?: boolean; // Открыт ли список (если управляется родителем)
  onClick?: () => void; // Коллбек при клике (если управляется родителем)
  customHeaderIcon?: React.ReactNode;
  children: React.ReactNode; // Контент списка
  className?: string;
}

const Accordion: FC<IAccordionProps> = ({
  title,
  customHeaderIcon,
  isOpen,
  onClick,
  children,
  className,
}) => {
  // Внутреннее состояние для самоуправления, используется только если isOpen не передан
  const [internalOpen, setInternalOpen] = useState(false);
  // Ссылка на контент для измерения высоты
  const contentRef = useRef<HTMLDivElement>(null);
  // Текущая высота контента для плавной анимации
  const [height, setHeight] = useState('0px');
  // Определяем, управляется ли компонент извне
  const isControlled = isOpen !== undefined;
  // Выбираем текущее состояние открытости
  const open = isControlled ? isOpen : internalOpen;

  // Обновляем высоту при изменении состояния open или содержимого
  useEffect(() => {
    if (contentRef.current)
      setHeight(open ? `${contentRef.current.scrollHeight}px` : '0px');
  }, [open, children]);

  // Обработчик клика
  const handleClick = () => {
    if (onClick) onClick();
    else setInternalOpen((prev) => !prev);
  };

  return (
    <div
      className={cn(css.accordion, className, 'Accordion_component', {
        _isOpen: open,
      })}
    >
      <div className={css.accordion_header} onClick={handleClick}>
        <div className={css.accordion_title}>
          {customHeaderIcon}
          <span>{title}</span>
        </div>

        <FiChevronDown className={css.accordion_arrow} size={16} />
      </div>
      <div
        ref={contentRef}
        className={cn(css.accordion_wrapper, {
          _isOpen: open,
        })}
        style={{ maxHeight: height }}
      >
        <div className={cn(css.accordion_content, { _isOpen: open })}>
          {children}
        </div>
      </div>
    </div>
  );
};

export default Accordion;
